export const LEAGUE = 'league';
export const CLUB = 'club';
export const CUP = 'cup';
export const FRIENDLY = 'friendly';
export const DAMALLSVENSKAN = 'damallsvenskan';
export const EUROPEAN = 'european';
export const SUPERETTAN_QUALIFICATION = 'superettanQualification';
export const ALLSVENSKAN_QUALIFICATION = 'allsvenskanQualification';
export const FUTSAL = 'futsal';
export const SUPERETTAN = 'superettan';
export const ALLSVENSKAN = 'allsvenskan';

export const LEAGUES = {
  CUP: 'cup',
  FRIENDLY: 'friendly',
  DAMALLSVENSKAN: 'damallsvenskan',
  EUROPEAN: 'european',
  SUPERETTAN_QUALIFICATION: 'superettanQualification',
  ALLSVENSKAN_QUALIFICATION: 'allsvenskanQualification',
  FUTSAL: 'futsal',
  SUPERETTAN: 'superettan',
  ALLSVENSKAN: 'allsvenskan',
};

export const SPORTS = {
  FUTSAL: 'futsal',
  FOOTBALL: 'football',
};

export const LEAGUES_USING_TICKETS = ['allsvenskan', 'superettan'];
